// Medspa scoped feature flags (TODO, migrate the remaining global flags to this const)
export const FeatureFlags = {
  BALANCE_V1: "balance-v1",
  CHERRY_PAYMENTS_V1: "cherry-payments-v1",
  PACKAGES_ALLOW_RETAIL_PRODUCTS: "packages-allow-retail-products",
  MESSAGING_MAINTENANCE: "messaging-maintenance-v1",
  STANDING_ORDERS_V1: "standing-orders-v1",
  AFFIRM_PAYMENT_METHOD: "affirm-payment-method",
  VENMO_PAYMENT_METHOD: "venmo-payment-method",
  ZELLE_PAYMENT_METHOD: "zelle-payment-method",
  INVOICE_SUMMARY_UPDATE_SERVICES: "invoice-summary-update-services",
  SYNC_GFE_V2: "sync-gfe-v2",
  MARKETING_MESSAGES_V1: "marketing-messages-v1",
  COMMAND_AI: "commandai",
  MARKETING_MESSAGES_RESPONSE_V1: "marketing-messages-response-v1",
  ORDER_PRESCRIPTION_DRAWER_V1: "order-prescription-drawer-v1",
  SHOPIFY_PLUS: "shopify-plus",
  ONLINE_BOOKING_DEPOSITS_V1: "online-booking-deposits-v1",
  CHERRY_INTEGRATION_V1: "cherry-integration-v1",
  GLOBAL_SUPPLIES_SAVINGS_V1: "global-supplies-savings-v1",
  PAYROLL_INTEGRATION_V1: "payroll-integration-v1",
  PAYROLL_INTEGRATION_BENEFITS_NEXT: "payroll-integration-benefits-next",
  PAYROLL_INTEGRATION_BENEFITS_SIMPLY_INSURE:
    "payroll-integration-benefits-simply-insure",
  PAYROLL_INTEGRATION_BENEFITS_GUIDELINE:
    "payroll-integration-benefits-guideline",
  PAYROLL_EMPLOYEE_TABLE: "payroll-employee-table",
  ROLES_CONFIGURATION_V1: "roles-configuration-v1",
  STRIPE_NINE_PERCENT_INTEGRATION: "stripe-nine-percent-integration",
  PACKAGE_CARD_REVAMP_V1: "package-card-revamp-v1",
  IMPROVED_GFE_REQUEST_V1: "improved-gfe-request-v1",
  CLIENT_PHONE_OPTIONAL: "client-form-phone-optional",
  BANKING_REPORTS_V1: "banking-reports-v1",
  SCRIPTS_NAV_ITEM: "scripts-nav-item",
  INVENTORY_V3: "inventory-v3",
  PRACTICE_ACCELERATOR_V1: "practice-accelerator-v1",
  EMPLOYEES_SECTION: "employees-section",
  HRT_LABS_V1: "hrt-labs-v1",
  NEW_APPOINTMENT_MODEL: "new-appointment-model",
  REAL_TIME_SALES_V1: "real-time-sales-v1",
  SALES_ATTRIBUTION_V1: "sales-attribution-v1",
  PROVIDER_COLORS_CONFIG: "provider-colors-config",
  CHECK_IN_NOTIFICATIONS_V1: "check-in-notifications-v1",
  OVERRIDE_APPT_COMMS_V1: "override-appt-comms-v1",
  MEMBERSHIPS_ENHANCEMENTS_V1: "memberships-enhancements-v1",
  MEMBERSHIPS_ENHANCEMENTS_V3: "memberships-enhancements-v3",
  ALLOW_MD_UPLOAD_GFE_FILE: "allow-md-upload-gfe-file",
  CREATE_CLIENT_DRAWER: "create-client-drawer",
  MARKETING_CONTACTS_V1: "marketing-contacts-v1",
  ONLY_REQUIRE_CC_FOR_NEW_CLIENTS: "only-require-cc-for-new-clients",
  MEDICAL_DATA_EXPORT_V1: "medical-data-export-v1",
  CASH_DRAWER_V1: "cash-drawer-v1",
  INTAKE_FORM_MULTIPLE_PHOTOS: "intake-from-multiple-photos",
  EXCLUSIVE_TO_CUSTOM_BOOKING_LINKS_V1: "exclusive-to-custom-booking-links-v1",
  INTERCOM_V1: "intercom-v1",
  CLOCK_IN_CLOCK_OUT_V1: "clock-in-clock-out-v1",
  MULTI_PROVIDER_APPOINTMENTS_V1: "multi-provider-appointments-v1",
  WAITLIST_V1: "waitlist-v1",
  CLIENT_MERGE_V1: "client-merge-v1",
  MULTI_PROVIDERS_ONLINE_BOOKING_V1: "multi-providers-online-booking-v1",
  EXTERNAL_RN_ORDERING_V1: "external-rn-ordering-v1",
  GFE_IMPROVEMENTS_V1: "gfe-improvements-v1",
  FEATURE_MANAGEMENT_V1: "feature-management-v1",
  TREATMENT_PLANS_V1: "treatment-plans-v1",
  MEMBERSHIPS_ENHANCEMENTS_V4: "memberships-enhancements-v4",
  HIDE_EVENTS_ON_MEMBERSHIP_SALE_V1: "hide-events-on-membership-sales-v1",
} as const;

export type FeatureFlag = (typeof FeatureFlags)[keyof typeof FeatureFlags];
